export const PRODUCTS = {
  label: {
    en: 'Products used',
    nl: 'Gebruikte producten',
    de: 'Genutzte Produkte',
  },
  'Moss platform': {
    icon: 'moss-logo',
    label: {
      en: 'Moss platform',
      nl: 'Moss platform',
      de: 'Moss plattform',
    },
  },
  'Accounts payable': {
    icon: 'invoice',
    label: {
      en: 'Accounts Payable',
      nl: 'Crediteurenbeheer',
      de: 'Rechnungsmanagement',
    },
  },
  'Corporate cards': {
    icon: 'card',
    label: {
      en: 'Corporate Cards',
      nl: 'Betaalkaarten',
      de: 'Firmenkarten',
    },
  },
  Reimbursements: {
    icon: 'wallet',
    label: {
      en: 'Employee Reimbursements',
      nl: 'Declaraties',
      de: 'Rückerstattungen für Mitarbeiter',
    },
  },
  'Invoice management': {
    icon: 'invoice-2',
    label: {
      en: 'Invoice Management',
      nl: 'Facturen',
      de: 'Rechnungen',
    },
  },
  'Expense management': {
    icon: 'invoice-2',
    label: {
      en: 'Expense Management',
      nl: 'Uitgavenbeheer',
      de: 'Ausgabenmanagement',
    },
  },
}

export const ADD_ONS = {
  label: {
    en: 'Add-ons used',
    nl: 'Gebruikte Add-ons',
    de: 'Genutzte Add-ons',
  },
  'Advanced controlling': {
    icon: 'accounting',
    label: {
      en: 'Advanced Controlling',
      nl: 'Geavanceerde controlling',
      de: 'Erweitertes Controlling',
    },
  },
  'Advanced accounting': {
    icon: 'insights',
    label: {
      en: 'Advanced Accounting',
      nl: 'Geavanceerde boekhouding',
      de: 'Erweiterte Buchhaltung',
    },
  },
  Procurement: {
    icon: 'org-chart',
    label: {
      en: 'Procurement',
      nl: 'Procurement',
      de: 'Einkauf',
    },
  },
  ERP: {
    icon: 'request',
    label: {
      en: 'ERP',
      nl: 'ERP',
      de: 'ERP',
    },
  },
  Integrations: {
    icon: 'arrows-left-right',
    label: {
      en: 'Integrations',
      nl: 'Integraties',
      de: 'Integrationen',
    },
  },
}

export const CATEGORIES_ICONS = {
  Ecommerce: {
    icon: 'shopping-cart',
    label: {
      en: 'Ecommerce',
      de: 'E-commerce',
      nl: 'E-commerce',
    },
  },
  'Professional Services': {
    icon: 'company',
    label: {
      en: 'Professional Services',
      de: 'Dienstleistungen',
      nl: 'Professionele dienstverlening',
    },
  },
  Hospitality: {
    icon: 'dinner',
    label: {
      en: 'Hospitality',
      de: 'Gastgewerbe',
      nl: 'Hospitality',
    },
  },
  Technology: {
    icon: 'monitor',
    label: {
      en: 'Technology',
      de: 'Technologie',
      nl: 'Technologie',
    },
  },
}
